// Vendor Libs
import React from 'react';
import PropTypes from 'prop-types';
import {get} from 'lodash';

// Components
import SelectNetworkForm from './select-network-form';
import DashboardDisplayPaths from '../layout/dashboard-display-paths';

// Styles
import './select-network-for-display-paths.scss';

// Containers
import withForm from '../../containers/with-form';

const formName = 'selectNetworkForDisplayPaths';

function SelectNetworkForDisplayPaths({formData}) {
    const getFormProps = () => ({
        className: 'select-network-for-display-paths',
        formName,
    });

    const isNetworkSelected = () => !!get(formData, 'values.network.name');

    return (
        <>
            <SelectNetworkForm {...getFormProps()} />
            {isNetworkSelected() ? (
                <>
                    <hr className="select-network-for-display-paths--line" />
                    <div className="select-network-for-display-paths--wrapper">
                        <DashboardDisplayPaths />
                    </div>
                </>
            ) : null}
        </>
    );
}

SelectNetworkForDisplayPaths.propTypes = {
    formData: PropTypes.object,
};

export default withForm(SelectNetworkForDisplayPaths, formName);
